import React from "react";
import {
  Bar,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Label,
  ComposedChart,
  ResponsiveContainer,
} from "recharts";
import HomeCustomTick from "./homeCustomTick";
import HomeCustomTooltip from "./homeCustomTooltip";
import { formatNumberWithCommas } from "../../../util/formatNumber";

const HomeChart = ({ dataList }) => {
  // dataList를 역순으로 변환
  const reversedDataList = [...dataList].reverse();

  return (
    <div
      style={{
        width: "100%",
        height: "fit-content",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: "51px 0px",
      }}
    >
      <ResponsiveContainer width={956} height={256}>
        <ComposedChart
          data={reversedDataList}
          margin={{ top: 10, right: 20, left: 20, bottom: 20 }}
        >
          <CartesianGrid stroke="rgba(255, 255, 255, 0.12)" vertical={false} />
          <XAxis
            dataKey={"date"}
            axisLine={false}
            stroke="rgba(255, 255, 255, 0.12)"
            tickSize={0} // 눈금 제거
            tick={({ x, y, payload, index }) => (
              <HomeCustomTick
                x={x}
                y={y}
                payload={payload}
                index={index}
                data={reversedDataList}
              />
            )}
            tickMargin={28}
            interval={0}
          />
          <YAxis
            yAxisId="left"
            orientation="left"
            axisLine={false}
            stroke="rgba(255, 255, 255, 0.12)"
            width={76}
            tickFormatter={(value) => formatNumberWithCommas(value)}
            tickSize={0}
            tickMargin={20} // 숫자와 축 사이의 간격 조정
            tick={{
              fontFamily: "Pretendard",
              fontWeight: 500,
              fontSize: 13,
              lineHeight: "18.75px",
              fill: "#aaa",
              textAnchor: "end",
            }}
          >
            <Label
              value="(명)"
              position="insideBottom" // "insideBottomRight", "insideBottom", "insideBottomLeft", "insideTopRight", "insideTop", "insideTopLeft"
              offset={-26} // Y축에 가까이 붙게 하려면 offset 값을 음수로 설정
              dx={10}
              style={{
                fontFamily: "Pretendard",
                fontWeight: 500,
                fontSize: 13,
                lineHeight: "18.75px",
                fill: "rgba(181, 181, 181, 0.5)",
              }}
            />
          </YAxis>
          <YAxis
            yAxisId="right"
            orientation="right"
            axisLine={false}
            stroke="rgba(255, 255, 255, 0.12)"
            tickSize={0}
            tickFormatter={(value) => formatNumberWithCommas(value)}
            tickMargin={20} // 숫자와 축 사이의 간격 조정
            width={44}
            tick={{
              fontFamily: "Pretendard",
              fontWeight: 500,
              fontSize: 13,
              lineHeight: "18.75px",
              fill: "#aaa",
              textAnchor: "start",
            }}
          >
            <Label
              value="(회)"
              position="insideBottom" // "insideBottomRight", "insideBottom", "insideBottomLeft", "insideTopRight", "insideTop", "insideTopLeft"
              offset={-26} // Y축에 가까이 붙게 하려면 offset 값을 음수로 설정
              dx={5}
              style={{
                fontFamily: "Pretendard",
                fontWeight: 500,
                fontSize: 13,
                lineHeight: "18.75px",
                fill: "rgba(181, 181, 181, 0.5)",
              }}
            />
          </YAxis>
          <Tooltip cursor={false} content={<HomeCustomTooltip />} />
          <Bar
            yAxisId="left"
            dataKey="visitor"
            fill="#b658ff"
            radius={[5, 5, 0, 0]}
            barSize={14}
          />
          <Line yAxisId="right" dataKey="view" stroke="#34f3ff" type="linear" />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
};

export default HomeChart;
